export default __webpack_public_path__ + "static/media/pileta.160bacc9.svg";